module.exports = __webpack_public_path__ + "static/media/445SunsetAveNW_2018-06-06_62.6b4244c8.jpg";